import { useState } from "react";

import { MasonryPhotoAlbum } from "react-photo-album";
import "react-photo-album/columns.css";
import "react-photo-album/masonry.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useTranslation } from "react-i18next";

import { photos } from "./content/photos";

export const Gallery = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(-1);

  return (
    <div className="gallery">
      <div className="container">
        <h3 className="container-title">{t("gallery.title")}</h3>
      </div>
      <MasonryPhotoAlbum photos={photos} targetRowHeight={300} onClick={({ index }) => setIndex(index)} />

      <Lightbox
        slides={photos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
      <div className="container"></div>
    </div>
  );
}

export default Gallery;
